<template>
  <div>
    <Header />
    <Stepper />
    <div class="cert section">
      <form @submit.prevent="submit">
        <div class="grid">
          <p class=""><span class="point-red">필수입력</span></p>
          <div class="grid-item product">
            <div class="num-gift-card">
              <span>상품권번호</span><strong>{{product.gcct_no}}</strong>
            </div>
            <div class="img-product">
              <img :src="'/'+product.product_image_path+product.image_stre_file_name" alt=""/>
            </div>
            <div class="caption"><span>{{product.brand_product_name}}</span></div>
          </div>
          <div class="grid-item phone-num">
              <dl class="input-list">
                <dt>
                  <label for="ex01"><span class="essential">수신인 휴대폰 번호</span></label>
                </dt>
                <dd>
                  <div class="input-divide3" id="ex03">
                    <input type="number" name="phone1" @keyup="phoneCheck($event)" v-model="cert.phone_num1" class="input-default" v-validate="{required: true, min: 3, max:3}" data-vv-validate-on="change|focus|keyup">
                    <input type="number" name="phone2" @keyup="phoneCheck($event)" v-model="cert.phone_num2" class="input-default" v-validate="{required: true, min: 3, max:4}" data-vv-validate-on="change|focus|keyup">
                    <input type="number" name="phone3" @keyup="phoneCheck($event)" v-model="cert.phone_num3" class="input-default" v-validate="{required: true, min: 4, max:4}" data-vv-validate-on="change|focus|keyup">
                  </div>
                </dd>
                <dd>
                  <p class="on-error">숫자만 입력 가능합니다.</p>
                  <!--<p class="on-error on">숫자만 입력 가능합니다.</p>-->
                </dd>
              </dl>
              <button type="button" class="button-border gray" v-if="!isCert" @click="certification">
                <span class="certification before">인증</span>
              </button>

              <button type="button" class="button-border black" v-if="isCert">
                <span class="certification complete">인증완료</span>
              </button>
          </div>
          <div class="buttn-area">
            <button type="button" class="button-full gray" v-if="errors.any() || beginErrorStatus || !isCert">다음</button>
            <button type="submit" class="button-full blue" v-if="!errors.any() && !beginErrorStatus && isCert">다음</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Header from '@/components/Header';
import Stepper from '@/components/Stepper';
import axios from 'axios';

export default {
  name: "DeliverCert",
  components: {
    Header,
    Stepper
  },
  data(){
      return {
        pin : this.$route.params.pin,
        dataUrl : '', // 복호화
        product: {
          gcct_no: '',
          product_image_path: '',
          image_stre_file_name: '',
          brand_product_name: ''
        },
        prodImg: '',
        prdName: '',
        cert: {},
        isCert : false,
        beginErrorStatus : true
      }
  },
  computed: {
  },
  activated() {
    localStorage.removeItem('cert');
    this.pinData()
  },
  created(){
    localStorage.removeItem('cert');
    // console.log(this.$router)
    axios.post(`${process.env.ENDPOINT}/deliver/request`, {
      pin: this.pin
    })
    .then(response => {
      if(response.status==200){
        let data = response.data;
        if(data.return_cd === '0000'){
          // 등록된 배송정보가 있으면 배송조회 페이지로 이동
          if(data.response.saveYn === 'Y'){
            this.$router.push({ name: 'delivery-search', params: { pin: this.pin }})
          }
          // 데이터 바인딩
          else{
            this.product.gcct_no = data.response.img.gcct_no;
            this.product.product_image_path = data.response.img.product_image_path;
            this.product.image_stre_file_name = data.response.img.image_stre_file_name;
            this.product.brand_product_name = data.response.img.brand_product_name;
            this.prodImg = `/${this.product.product_image_path}${this.product.image_stre_file_name}`
            this.prdName = this.product.brand_product_name
            localStorage.product = JSON.stringify(this.product);
            console.log(this.product)
          }
        }
        else{
          console.log('cd error :', data.return_cd);
        }
      }
    })
    .catch(error => {
      console.log(error);
    });
    this.pinData()
  },
  methods:{
    submit(){
      localStorage.cert = JSON.stringify(this.cert);
      this.$router.push({ name: 'deliver-register',params: { pin: this.pin, img: this.prodImg, prdNm: this.prdName }});
    },
    pinData() {
      axios.post(`${process.env.ENDPOINT}/decrypt/pin`, {
        pin: this.pin
      })
      .then(response => {
        if(response.status==200){
          let data = response.data.response.data;
          // pin 복호화
          this.dataUrl = data
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    phoneCheck(e){
        if(this.beginErrorStatus===true) this.beginErrorStatus = false;
        let len = e.target.value.length;
        if(e.target.name==='phone1'){
            if(len == 3){
                document.querySelector("input[name=phone2]").focus();
            }
        }else if(e.target.name==='phone2'){
            if(len == 4){
              document.querySelector("input[name=phone3]").focus();
            }
        }else if(e.target.name==='phone3'){
            if(len > 4){
              let phone3 = e.target;
              phone3.value = phone3.value.slice(0,4)
            }
        }
    },
    certification(){
      axios.post(`${process.env.ENDPOINT}/deliver/request/phone/confirm`, {
        pin: this.pin,
        rcpr_hp_tel: this.cert.phone_num1+this.cert.phone_num2+this.cert.phone_num3
      })
      .then(response => {
        if(response.status==200){
        let data = response.data;
        console.log(data)
        if(data.return_cd === '0000'){
          // console.log('rcpr_hp_auth_yn',data.response.data.rcpr_hp_auth_yn);
          if(data.response.data.rcpr_hp_auth_yn === 'Y'){
            this.isCert = true;
          }
          else{
            alert(data.return_msg);
          }
        }
        else{
          console.log('cd error :', data.return_cd);
        }
      }
        console.log('Cert Result',response);
      })
      .catch(error => {
        console.log(error);
      });
    }
  }
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/contents.scss';

input {
  -webkit-appearance: none;
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/DeliverCert.vue